import {FieldRequirement, isRegistrationStepRequired} from './registrationFlow';

const RESIDENT_CODE_LENGTH = 16;

export type ResidentCodeStepValues = {
	code: string;
	skipped: boolean;
};

export const EMPTY_RESIDENT_CODE: ResidentCodeStepValues = {
	code: '',
	skipped: false,
};

export const extractResidentCodeDigits = (value: string): string => {
	return value.replace(/\D/g, '').slice(0, RESIDENT_CODE_LENGTH);
};

export const formatResidentCodeDisplay = (digits: string): string => {
	const normalized = extractResidentCodeDigits(digits);

	if (!normalized) {
		return '';
	}

	return normalized.match(/.{1,4}/g)?.join(' ') ?? normalized;
};

export const isResidentCodeDigitsValid = (digits: string): boolean => {
	return extractResidentCodeDigits(digits).length === RESIDENT_CODE_LENGTH;
};

export const isResidentCodeStepValidForRequirement = (
	requirement: FieldRequirement,
	values: ResidentCodeStepValues,
): boolean => {
	if (!isRegistrationStepRequired(requirement) && values.skipped) {
		return true;
	}

	return isResidentCodeDigitsValid(values.code);
};

export const canSkipResidentCodeStep = (requirement: FieldRequirement): boolean => {
	return !isRegistrationStepRequired(requirement);
};

export const buildResidenceCodeRequest = (values: ResidentCodeStepValues): {residenceCode: string} | null => {
	if (values.skipped || !isResidentCodeDigitsValid(values.code)) {
		return null;
	}

	return {residenceCode: formatResidentCodeDisplay(values.code)};
};
